import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployeeStatus, EmployeeType, PatientStatus } from '@ffd/api-client';
import { AvatarsComponent, TooltipModule } from '@libs/ui-lib';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { SelectedParticipant } from './selected.participant.vm';

@Component({
  selector: 'lib-selected-participant',
  imports: [CommonModule, AvatarsComponent, TranslateModule, SvgIconComponent, TooltipModule],
  templateUrl: './selected-participant.component.html',
  styleUrl: './selected-participant.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedParticipantComponent implements OnChanges {
  @Input({ required: true }) public participant!: SelectedParticipant;
  @Output() public readonly removeParticipant = new EventEmitter<SelectedParticipant>();

  protected readonly EmployeeStatus = EmployeeStatus;
  protected readonly EmployeeType = EmployeeType;
  protected readonly PatientStatus = PatientStatus;
  protected readonly isValidStatus = signal<boolean>(false);

  public ngOnChanges(): void {
    if (this.participant) {
      this.isValidStatus.set(
        !!this.participant?.status &&
          (this.participant.status === EmployeeStatus.NOT_INVITED ||
            this.participant.status === PatientStatus.NOT_INVITED ||
            this.participant.status === EmployeeStatus.PENDING ||
            this.participant.status === PatientStatus.PENDING),
      );
    }
  }

  protected onRemoveParticipant(): void {
    this.removeParticipant.emit(this.participant);
  }
}
